import {defineStore} from 'pinia'
import type {ICustomer, ISettings,} from "@torim-app/types";
import {IAdminClientsStore, IAdminSettingsStore} from "@app/types";
import {CustomersApi} from "@app/api/admin/customers-api";
import {SettingsApi} from "@app/api/admin";

export const useAdminSettingsStore = defineStore('admin-settings', {
  state: (): IAdminSettingsStore => ({
    settings: <ISettings>{},
  }),
  getters: {
    getSettings(state): ISettings {
      return state.settings;
    },
  },
  actions: {
    async fetchBusinessSettings() {
      try {
        this.settings = await SettingsApi.getSettings();
      } catch (e) {
        console.error(e)
        throw e;
      }
    },
  }
})
